module.exports = __webpack_public_path__ + "img/79.30ca9276.webp";